import { useQuery } from '@tanstack/react-query';
import { getAllCentersPaginateAsListUtil, getStatsCenter, getStatsMoreCentersOrders } from '../../api/centerApi';
import { getAllCenters } from '../../api/carteleriaApi';
import useQueryParams from '../../hooks/useQueryParams';
import { useAuth0 } from '@auth0/auth0-react';

export const useGetMoreCentersOrders = () => {
  return useQuery({
    queryKey: ['stats-more-centers-orders'],
    queryFn: () => getStatsMoreCentersOrders(),
  });
};

export const useGetAllCenters = () => {
  const { getAccessTokenSilently } = useAuth0();
  return useQuery({
    queryKey: ['all-centers'],
    queryFn: async () => {
      const token = await getAccessTokenSilently();
      const data = await getAllCenters(token);
      return data;
    },
  });
};

export const useGetCenterStats = () => {
  const [{ center }] = useQueryParams(['center']);

  return useQuery({
    queryKey: ['center-stats', center],
    queryFn: () => getStatsCenter(center),
    enabled: !!center,
    retry: false,
  });
};

export const useGetCentersPaginateListUtil = () => {
  const [{ search = '', page = 1, active = 'all' }] = useQueryParams(['search', 'page', 'active']);
  const { getAccessTokenSilently } = useAuth0();

  return useQuery({
    queryKey: ['centers-list-util', { page, search, active }],
    queryFn: async () => {
      const token = await getAccessTokenSilently();

      return getAllCentersPaginateAsListUtil(token, { page, search, active });
    },
  });
};
